export class LlmClientTokenPricing {
  public input: number;
  public output: number;
  public cacheWrite?: number | null;
  public cacheRead?: number | null;
  public batchInput?: number | null;
  public batchOutput?: number | null;

  constructor(data: any = {}) {
    this.input = data.input || 0;
    this.output = data.output || 0;
    this.cacheWrite = data.cacheWrite || null;
    this.cacheRead = data.cacheRead || null;
    this.batchInput = data.batchInput || null;
    this.batchOutput = data.batchOutput || null;
  }
}
